<template>
  <div :class="{ 'avatar': true, 'has-image': avatarUrl }">
    <img
      v-if="avatarUrl"
      :src="avatarUrl"
      alt="" />

    <span
      v-if="!avatarUrl"
      :style="'background-color:' + avatarColor + '; color: ' + textColor + ';'"
      class="initials">
      <template v-if="worker.avatar_initials">{{ worker.avatar_initials }}</template>
      <template v-else>{{ initials }}</template>
    </span>

    <span :class="'tooltip tooltip-' + tooltipPosition">
      {{ name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'avatar',
  props: {
    'worker': {
      default: null
    },
    'name': {
      default: null
    },
    'tooltipPosition': {
      default: 'right'
    }
  },
  computed: {
    avatarColor () {
      if (!this.worker.avatar_color) {
        return '#b6d8e9';
      }

      return this.worker.avatar_color;
    },
    textColor () {
      let hex = this.avatarColor.slice(1);

      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      let r = parseInt(hex.slice(0, 2), 16);
      let g = parseInt(hex.slice(2, 4), 16);
      let b = parseInt(hex.slice(4, 6), 16);

      return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';
    },
    avatarUrl () {
      if (this.worker && this.worker.avatar && this.worker.avatar.indexOf('http') > -1) {
        return this.worker.avatar;
      }

      return false;
    },
    initials () {
      if (typeof this.name !== 'string') {
        return '??';
      }

      let shortName = this.name.trim().split(' ').filter(word => word.length > 2).map(word => word[0].toUpperCase());

      if (shortName.length > 2) {
        return shortName[0] + shortName[1];
      }

      return shortName.join('');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.avatar {
  background: darken($color-bg-medium, 10%);
  border-radius: $border-radius-full;
  height: 32px;
  position: relative;
  width: 32px;

  &:hover {
    z-index: 10;
  }

  &.has-image {
    background: $color-light;
    border: 1px solid $color-border;
  }

  .initials {
    border-radius: 50%;
  }

  img {
    border-radius: $border-radius-full;
    display: block;
    height: 32px;
    overflow: hidden;
    object-fit: cover;
    object-position: center top;
    width: 32px;
  }

  span {
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    font-weight: 600;
    height: 32px;
    justify-content: center;
    line-height: 1;
    user-select: none;
    width: 32px;
  }

  &:hover {
    .tooltip {
      opacity: 1;
      top: 50%;

      &.tooltip-top {
        top: -36px;
      }
    }
  }

  .tooltip {
    background: $color-dark;
    border-radius: $border-radius-small;
    color: $color-light;
    display: block;
    font-size: 1.4rem;
    font-weight: 400;
    height: 2.6rem;
    left: 36px;
    opacity: 0;
    padding: .5rem 1rem 0 1rem;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all .25s ease-out;
    white-space: nowrap;
    width: auto;
    z-index: 1;

    &:after {
      border: .5rem solid $color-dark;
      border-left-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
      bottom: -1rem;
      content: "";
      height: 1rem;
      left: -1rem;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 1rem;
    }

    &.tooltip-top {
      left: 50%;
      top: -24px;
      transform: translateX(-50%);

      &:after {
        border: .5rem solid $color-dark;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        bottom: -1rem;
        content: "";
        height: 1rem;
        left: 50%;
        position: absolute;
        top: auto;
        transform: translateX(-50%);
        width: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Avatar.vue